<template>
  <section
    v-if="products && products.length"
    class="similar-products-search-box  text-right mt-5"
  >
    <div class="d-flex justify-content-between align-items-baseline ">
      <h4 class="title">محصولات مشابه</h4>
    </div>
    <div class="  sim-products px-0 pt-4 ">
      <div class=" recommended-content-item swiper-container">
        <div
          class="swiper-wrapper "
          v-if="products != '' && !disabledSliders.includes('myProducts')"
        >
          <div
            class="swiper-slide px-1 box-shaddow20"
            v-for="(product, index) in products"
            :key="index"
          >
            <Product :product="product"></Product>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Swiper from "swiper/swiper-bundle.min";
import Product from "@/parts/Front/components/product/Product";
export default {
  props: {
    related: Array,
    products:Array
  },
  components: {
    Product,
  },
  data() {
    return {
      disabledSliders: [],
    };
  },
  mounted() {
    this.initRelatedProducts();
    this.setActiveProducts(this.activeTab);
  },
  methods: {
    initRelatedProducts(kill = false) {
      this.initSwiper("myProducts", kill, () => {
        new Swiper(".similar-products-search-box .swiper-container", {
          spaceBetween: 30,
          // centeredSlides: true,
          loop: false,
          speed: 500,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".similar-products-search-box .swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            250: {
              slidesPerView: 2,
              spaceBetween: 1,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            // 1200: {
            // slidesPerView: 3,
            // spaceBetween: 0,
            // }
          },
        });
      });
    },
    async setActiveProducts(tab) {
      this.products = null;
      let res = await this.$store.dispatch(
        "front/getIndexPageContent",
        "new-products"
      );
      this.products = res;
    },
  },
  computed: {
    productList() {
      return this.products;
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 18px !important;
  font-weight: 800;
}
</style>
<style>
.similar-products-search-box .btn-add-product a {
  font-size: 12px;
  white-space: nowrap;
  padding: 8px 8px !important;
}
.similar-products-search-box .swiper-container {
  overflow: unset;
}
/* .similar-products-search-box .swiper-button-prev,.similar-products-search-box .swiper-button-next {
    width: 15px !important;
    height: 15px !important;
  } */
.similar-products-search-box .container {
  overflow-x: hidden;
}
.similar-products-search-box .swiper-button-prev::after,
.similar-products-search-box .swiper-button-next::after {
  content: "unset" !important;
}
.similar-products-search-box .swiper-pagination-bullet {
  margin: 0 2px;
}
.similar-products-search-box .swiper-pagination {
  position: unset;
}
.sim-products {
  overflow: hidden;
}
</style>
